import { isGraphPointer } from 'is-graph-pointer';
import s2q from '../../ns.js';
import NodeExpressionBase from './NodeExpression.js';
export class OptionalExpression extends NodeExpressionBase {
    static match(pointer) {
        return isGraphPointer(pointer.out(s2q.optional));
    }
    static fromPointer(pointer, factory) {
        const inner = pointer.out(s2q.optional);
        return new OptionalExpression(pointer.term, factory.nodeExpression(inner));
    }
    get requiresFullContext() {
        return this.inner.requiresFullContext;
    }
    get rootIsFocusNode() {
        return this.inner.rootIsFocusNode;
    }
    constructor(term, inner) {
        super();
        this.term = term;
        this.inner = inner;
    }
    _buildPatterns(arg, builder) {
        return {
            type: 'optional',
            patterns: builder.build(this.inner, arg).patterns,
        };
    }
}
